<div class="master-modal reviepw_items_modal" role="dialog">
  <div class="modal-dialog">
    <!-- Modal content-->
    <div class="modal-content">
      <!-- Modal-Header -->
      <div class="modal-header">
        <h4 class="modal-title"> Reject </h4>
        <div class="modal_close_btn">
          <span (click)="closeDialog('no')" class="modal-close"><i class="material-icons">close</i></span>
        </div>
      </div>
      <form [formGroup]="rejectionForm" (ngSubmit)="updateSecondHandSupply()">
      <!-- Modal content-->
        <perfect-scrollbar class="modal-body-scrollbar">
          <div mat-dialog-content>
            <div class="modal-body">
               <p>
                 Are you really want to reject this pre owned supplies ?
               </p>
               <mat-form-field appearance="outline">
                 <textarea matInput formControlName="rejection_reason" placeholder="Enter rejection reason"></textarea>
                 <mat-error *ngIf="rejection_reason.invalid && (rejection_reason.dirty || rejection_reason.touched)">
                    <span *ngIf="rejection_reason.hasError('required')">
                      Rejection reason is required  </span>
                 </mat-error>
               </mat-form-field>
            </div>
          </div>
        </perfect-scrollbar>
        <!-- Modal-Footer -->
        <div class="modal-footer">
          <div mat-dialog-actions class="modal_footer">
            <button type="button" mat-button (click)="closeDialog('no')" class="modal-cancel-btn modal-footer-btn">
              <span> Cancel </span>
            </button>
            <button type="submit" mat-button class="modal-save-btn global-btn modal-footer-btn">
              <span> Reject </span>
            </button>
          </div>
        </div>
      </form>

    </div>
  </div>
</div>
